import evaIconData from './eva-icon-data';
import App from './App.svelte';
import { EMBED_TYPE_ARR } from './config';
const HEADER_STYLE_ATTRIBUTE = 'data-ravely-style';
const EMBED_TYPE_ATTRIBUTE = 'data-ravely-embed-type';
setStyleInHeader();
const appProperties = getAppProperties();
// Shadow dom replaces the dom tree of the host so we put it inside
// a contents div instead of directly inside document body.
// https://stackoverflow.com/a/47501350
const shadowRoot = appProperties.rootDiv.attachShadow({ mode: 'closed' });
const app = new App({
    target: shadowRoot,
    props: {
        businessKey: appProperties.businessKey,
        embedType: appProperties.embedType,
    },
});
function setStyleInHeader() {
    if (document.querySelector(`style[${HEADER_STYLE_ATTRIBUTE}='true']`)) {
        return;
    }
    // Insert custom font face here because font face does not work in shadow dom (as of 30 Jul 2021)
    // https://stackoverflow.com/a/60526280
    const headStyle = document.createElement('style');
    headStyle.setAttribute(HEADER_STYLE_ATTRIBUTE, 'true');
    headStyle.innerHTML = `@font-face {
  font-family: ravely-eva-icons;
  src: url(${evaIconData});
  font-style: normal;
  font-weight: 400;
  font-display: block;
}`;
    document.head.appendChild(headStyle);
}
function getAppProperties() {
    const currentScript = document.currentScript;
    const currentScriptSrc = currentScript.getAttribute('src');
    const srcKey = (currentScriptSrc.indexOf('?') > -1 && currentScriptSrc.split('?').pop()) ||
        '';
    const href = window.location.href;
    const hrefKey = (href.indexOf('?') > -1 && href.split('?').pop()) || '';
    const embedType = currentScript.getAttribute(EMBED_TYPE_ATTRIBUTE);
    const rootDiv = getRootDiv(currentScript, embedType);
    return {
        businessKey: srcKey || hrefKey,
        rootDiv,
        embedType,
    };
}
function getRootDiv(currentScript, embedType) {
    const rootDiv = document.createElement('div');
    rootDiv.setAttribute('style', [
        'display: contents !important',
        'background-color: transparent !important',
    ].join('; ') + ';');
    if (EMBED_TYPE_ARR.includes(embedType)) {
        currentScript.insertAdjacentElement('afterend', rootDiv);
    }
    else {
        document.body.appendChild(rootDiv);
    }
    return rootDiv;
}
export default app;
